{
  "lexicon": 1,
  "id": "pub.oxa.document",
  "defs": {
    "main": {
      "type": "record",
      "description": "A document with metadata, title, and block content.",
      "key": "tid",
      "record": {
        "type": "object",
        "properties": {
          "id": { "type": "string" },
          "classes": {
            "type": "array",
            "items": { "type": "string" }
          },
          "data": { "type": "unknown" },
          "metadata": { "type": "unknown" },
          "title": {
            "type": "ref",
            "ref": "pub.oxa.blocks.defs#richText"
          },
          "children": {
            "type": "array",
            "items": {
              "type": "ref",
              "ref": "pub.oxa.blocks.defs#block"
            }
          },
          "createdAt": {
            "type": "string",
            "format": "datetime"
          }
        },
        "required": ["children", "createdAt"]
      }
    }
  }
}
